import {api, clientSettings, customerSettings} from '../../../stores/api.ts';
import { z } from 'zod';
import {ApiFilterBuilder} from "@automapa/svelte-automapa-template";
import {difference, polygon} from '@turf/turf';
import {get} from "svelte/store";
import {resetFilterQuery} from "./getFilterQuery.ts";
import { ConnectionApi } from './ConnectionApi.ts';
import {_} from '../telematics/Lang.class.js';

import {vehicleParcelIcon} from "../../shared/Icons/VehicleIcons.ts";

import calendarIcon from '../../shared/Icons/svg/calendar_today_FILL0_wght400_GRAD0_opsz24.svg';

export const getJobLabel = function(job) {
    let jobName = [];
    if (job.target_date) {
        jobName.push('<img src="'+calendarIcon+'" style="vertical-align: middle; position: relative; top: -1px; width: 14px; height: 14px; filter: invert(1);"/>'+job.target_date.replace(/\d{4}-(\d{2})-(\d{2})/, '$2.$1').replace(/^0/, ''));
    }
    if (job.parcels) {
        jobName.push('<img src="data:image/svg+xml;base64,'+btoa(vehicleParcelIcon.replace(/{color}/g, '#fff'))+'" style="vertical-align: middle; width: 14px; height: 14px"/> '+job.parcels);
    }
    if (jobName.length) {
        return '<span>'+jobName.join('</span><span>')+'</span>';
    } else {
        return '';
    }
}


export const getJobPin = function(color, size, opts, icon_style ='classic') {
    if (!size) {
        size = 40;
    }
    opts = Object.assign({type: 'delivery'}, opts || {});
    if (!opts.type && opts.type!==null) {
        opts.type = 'delivery';
    }
    let rgb = {r: parseInt(color.substr(1, 2), 16), g: parseInt(color.substr(3, 2), 16), b: parseInt(color.substr(5, 2), 16)};
    opts.contrastingColor = (rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114) > 186 ? '#000000' : '#ffffff';
    if (opts.colorOpacity && opts.colorOpacity < 1) {
        opts.colorOpacity = ('0'+Math.round(255 * opts.colorOpacity).toString(16)).slice(-2);
    } else {
        opts.colorOpacity = '';
    }
    switch (opts.type) {
        case 'delivery':
            //opts = Object.assign({backgroundColor: '#ffffff', borderColor: '#414741'}, opts);
            opts.symbol = 'arrow_down';
            break;
        case 'collection':
            //opts = Object.assign({backgroundColor: '#000000', borderColor: '#111111'}, opts);
            opts.symbol = 'arrow_up';
            break;
    }

    let svg = '';
    let spread = '';
    let w = 0;
    let h = 0;
    let x = 0;
    let y = 0;
    let spreadSize = Math.ceil(size*3/4);

    let icon;

    switch (icon_style) {
        case 'outline':
            opts = Object.assign({borderColor: '#000000'}, opts || {});
            size = Math.round(size*0.8);
            w = Math.round(size);
            h = Math.round(size);
            x = Math.round(size/2);
            y = size- Math.round(size/40) + 5;
            svg = getSVGOutline(size, color, opts);
            spread = (`
                <circle cx="`+(Math.floor(spreadSize/2)-0)+`" cy="`+(Math.floor(spreadSize/2)-0)+`" r="`+(Math.floor(spreadSize/2)-1)+`" stroke-width="1" stroke="{borderColor}"/>
                <circle cx="`+(Math.floor(spreadSize/2)-0)+`" cy="`+(Math.floor(spreadSize/2)-0)+`" r="`+(Math.floor(spreadSize/2)-2)+`" stroke-width="2" stroke="{backgroundColor}" fill="{color}{colorOpacity}"/>`)
                    .replace(/\{color\}/g, color)
                    .replace(/\{backgroundColor\}/g, opts.backgroundColor)
                    .replace(/\{borderColor\}/g, opts.borderColor)
                    .replace(/\{colorOpacity\}/g, opts.colorOpacity);
            break;
        case 'bold':
            opts = Object.assign({borderColor: '#000000'}, opts || {});
            size = Math.round(size*0.8);
            w = Math.round(size);
            h = Math.round(size);
            x = Math.round(size/2);
            y = size- Math.round(size/40) + 5;
            svg = getSVGBold2(size, color, opts);
            spread = (`
                <circle cx="`+(Math.floor(spreadSize/2)-0)+`" cy="`+(Math.floor(spreadSize/2)-0)+`" r="`+(Math.floor(spreadSize/2)-1)+`" stroke-width="1" stroke="{borderColor}"/>
                <circle cx="`+(Math.floor(spreadSize/2)-0)+`" cy="`+(Math.floor(spreadSize/2)-0)+`" r="`+(Math.floor(spreadSize/2)-2)+`" stroke-width="2" stroke="{backgroundColor}" fill="{color}{colorOpacity}"/>`)
                .replace(/\{color\}/g, color)
                .replace(/\{backgroundColor\}/g, opts.backgroundColor)
                .replace(/\{borderColor\}/g, opts.borderColor)
                .replace(/\{colorOpacity\}/g, opts.colorOpacity);
            break;
        default: // classic
            opts = Object.assign({backgroundColor: '#ffffff', borderColor: '#414741'}, opts || {});
            w = size;
            h = size;
            x = Math.round(size/2);
            y = size - Math.round(size/40);
            svg = getSVGClassic(size, color, opts);
            spread = (`
                <linearGradient id="SVGID_1_" x1="0" y1="0" x2="1.15197" y2="1.20891">
                    <stop offset="0" stop-color="{color}{colorOpacity}"/>
                    <stop offset="0.3" stop-color="{color}{colorOpacity}"/>
                    <stop offset="1" stop-color="{color_dark}{colorOpacity}"/>
                </linearGradient>
                <circle cx="`+(Math.floor(spreadSize/2)-0)+`" cy="`+(Math.floor(spreadSize/2)-0)+`" r="`+(Math.floor(spreadSize/2)-1)+`" stroke-width="1" stroke="{borderColor}"/>
                <circle cx="`+(Math.floor(spreadSize/2)-0)+`" cy="`+(Math.floor(spreadSize/2)-0)+`" r="`+(Math.floor(spreadSize/2)-2)+`" stroke-width="2" stroke="{backgroundColor}" fill="url(#SVGID_1_)"/>`)
                    .replace(/\{color\}/g, color)
                    .replace('{color_dark}', '#'+((s) => { return [s.slice(1,2), s.slice(3,4), s.slice(5,6)]; })('#ff0000').map((v) => { return ('0'+Math.max(0, (parseInt(v, 16) - 50)).toString(16)).slice(-2); }).join('')).replace(/\{size\}/g, size)
                    .replace(/\{backgroundColor\}/g, opts.backgroundColor)
                    .replace(/\{borderColor\}/g, opts.borderColor)
                    .replace(/\{colorOpacity\}/g, opts.colorOpacity);
            break;
    }

    icon = {
        imageUrl: 'data:image/svg+xml;base64,'+btoa(svg),
        w: w,
        h: h,
        coordsAnchor: {x: x, y: y}
    };
    if (spread) {
        if (typeof(spread) == 'string') {
            icon.spread = {
                icon: {
                    imageUrl: 'data:image/svg+xml;base64,'+btoa('<svg viewBox="0 0 '+spreadSize+' '+spreadSize+'" width="'+spreadSize+'" height="'+spreadSize+'" xmlns="http://www.w3.org/2000/svg">'+spread+'</svg>'),
                    w: spreadSize, h: spreadSize, coordsAnchor: {x: Math.floor(spreadSize/2), y: Math.floor(spreadSize/2)}
                },
                spreadIconRadius: Math.ceil(spreadSize*0.6),
                iconRadius: Math.ceil(w*0.6)
            };
        } else {
            icon.spread = spread;
        }
    }
    return icon;
}


export const getJobGroup = function(color, size, opts) {
    let text = ``;
    if (!opts.fontColor) {
        opts.fontColor = {r: parseInt(color.substr(1, 2), 16), g: parseInt(color.substr(3, 2), 16), b: parseInt(color.substr(5, 2), 16)};
        opts.fontColor = (opts.fontColor.r * 0.299 + opts.fontColor.g * 0.587 + opts.fontColor.b * 0.114) > 186 ? '#000000' : '#ffffff';
    }
    if (!opts.backgroundColor) {
        opts.backgroundColor = opts.fontColor;
    }
    let fontSize, subFontSize;
    if (typeof(opts.filtered) == 'number') {
        fontSize = Math.min(12, Math.ceil(18 * 2 / (opts.filtered.toString().length + opts.total.toString().length * 3/4)));
        text = `<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" textLength="20" fill="{fontColor}" style="font-family: sans-serif; font-weight: bold; font-size: {fontSize}px; color: {fontColor}">
                    {filtered}
                    <tspan dy="1px" style="font-weight: normal; font-size: 75%; opacity: 0.85">/ {total}</tspan>
                </text>`.replace('{filtered}', opts.filtered.toString());
    } else if (opts.total) {
        fontSize = Math.min(14, Math.ceil(18 * 2 / opts.total.toString().length));
        text = `<text x="50%" y="50%" fill="{fontColor}" dominant-baseline="middle" text-anchor="middle"`+(opts.total >= 100 ? ` textLength="20"` : ``)+` style="font-family: sans-serif; font-weight: bold; font-size: {fontSize}px; color: {fontColor}">{total}</text>`;
    }
    subFontSize = Math.ceil(0.75 * fontSize)
    let svg = `
        <svg viewBox="0 0 32 32" width="{size}" height="{size}" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="14" fill="{backgroundColor}"/>
            <circle cx="16" cy="16" r="12" fill="{color}"/>
            <!--<circle cx="16" cy="16" r="15" fill="none" stroke="{color}" stroke-width="1"/>-->
            <path d="M 23.5 3.01 A 15 15 0 0 0 8.5 3.01 M 1 16 A 15 15 0 0 0 8.5 28.99 M 23.5 28.99 A 15 15 0 0 0 31 16" fill="none" stroke="{color}" stroke-width="2"/>
            {text}
        </svg>
    `.replace('{text}', text).replace('{fontSize}', fontSize).replace(/\{color\}/g, color).replace(/\{backgroundColor\}/g, opts.backgroundColor).replace(/\{fontColor\}/g, opts.fontColor).replace(/\{size\}/g, size).replace('{total}', (opts.total || '').toString());
    let icon = {
        imageUrl: 'data:image/svg+xml;base64,'+btoa(svg),
        w: size,
        h: size,
        coordsAnchor: {x: Math.floor(size/2), y: Math.floor(size/2)}
    }
    return icon;
}


const getSVGClassic = function(size, color, opts) {
    let symbol = '';
    switch (opts.symbol) {
        case 'arrow_up':
            symbol = `
                <line x1="10" y1="4" x2="10" y2="12" stroke="{contrastingColor}" stroke-width="1.5" stroke-linecap="round"/>
                <line x1="10" y1="4" x2="7.5" y2="6.5" stroke="{contrastingColor}" stroke-width="1.5" stroke-linecap="round"/>
                <line x1="10" y1="4" x2="12.5" y2="6.5" stroke="{contrastingColor}" stroke-width="1.5" stroke-linecap="round"/>
            `.replace(/\{contrastingColor\}/g, opts.contrastingColor);
    }
    let svg = `<svg viewBox="0 0 20 20" width="{size}" height="{size}" xmlns="http://www.w3.org/2000/svg">
    <g>
     <linearGradient id="SVGID_1_" x1="0" y1="0" x2="1.15197" y2="1.20891">
      <stop offset="0" stop-color="{color}{colorOpacity}"/>
      <stop offset="0.3" stop-color="{color}{colorOpacity}"/>
      <stop offset="1" stop-color="{color_dark}{colorOpacity}"/>
     </linearGradient>
     <g id="svg_1">
      <path id="svg_2" d="m9.15592,17.5062c-0.656,-1.479 -1.672,-2.795 -2.655,-4.069c-1.475,-1.913 -3,-3.891 -3,-6.251c0,-3.679 2.947,-6.672 6.569,-6.672s6.569,2.993 6.569,6.672c0,2.355 -1.525,4.336 -3,6.251l-0.138,0.18c-0.932,1.224 -1.896,2.49 -2.518,3.89l-0.915,2.059l-0.912,-2.06z" stroke-linejoin="round" stroke-linecap="round" stroke="{borderColor}" stroke-width="0.3" fill="{backgroundColor}"/>
     </g>
     <path id="svg_3" d="m12.84692,12.8262c-1.012,1.331 -2.075,2.694 -2.777,4.275c-0.701,-1.581 -1.764,-2.961 -2.777,-4.275c-1.438,-1.865 -2.792,-3.627 -2.792,-5.641c0,-3.127 2.498,-5.672 5.569,-5.672c3.071,0 5.569,2.545 5.569,5.672c0,2.014 -1.356,3.776 -2.792,5.641z" stroke-linejoin="round" stroke-linecap="round" stroke="{backgroundColor}" fill="url(#SVGID_1_)"/>
     {symbol}
    </g>
    </svg>`
        .replace('symbol', symbol)
        .replace(/\{color\}/g, color)
        .replace('{color_dark}', opts.darkColor || '#'+((s) => { return [s.slice(1,2), s.slice(3,4), s.slice(5,6)]; })('#ff0000').map((v) => { return ('0'+Math.max(0, (parseInt(v, 16) - 50)).toString(16)).slice(-2); }).join(''))
        .replace(/\{size\}/g, size)
        .replace(/\{backgroundColor\}/g, opts.backgroundColor)
        .replace(/\{borderColor\}/g, opts.borderColor)
        .replace(/\{colorOpacity\}/g, opts.colorOpacity);
    return svg;
}

const getSVGOutline = function(size, color, opts) {
    if (!opts.borderColor) {
        opts.borderColor = opts.backgroundColor;
    }
    let symbol = '';
    switch (opts.symbol) {
        case 'arrow_up':
            symbol = `
                <line x1="184" y1="70" x2="184" y2="250" stroke="{contrastingColor}" stroke-width="15" stroke-linecap="round"/>
                <line x1="184" y1="70" x2="134" y2="120" stroke="{contrastingColor}" stroke-width="15" stroke-linecap="round"/>
                <line x1="184" y1="70" x2="234" y2="120" stroke="{contrastingColor}" stroke-width="15" stroke-linecap="round"/>
            `.replace(/\{contrastingColor\}/g, opts.contrastingColor);
    }
    let svg = `<svg fill="{borderColor}" width="{size}" height="{size}" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
 viewBox="0 0 368.553 368.553" xml:space="preserve">
<path fill="{color}{colorOpacity}" d="M 184.277 0 c -71.683 0 -130 58.317 -130 130 c 0 87.26 119.188 229.855 124.263 235.883 c 1.417 1.685 3.504 2.66 5.705 2.67 c 0.011 0 0.021 0 0.032 0 c 2.189 0 4.271 -0.957 5.696 -2.621 c 5.075 -5.926 124.304 -146.165 124.304 -235.932 C 314.276 58.317 255.96 0 184.277 0 z z" />
<path fill="{borderColor}" d="M184.277,0c-71.683,0-130,58.317-130,130c0,87.26,119.188,229.855,124.263,235.883c1.417,1.685,3.504,2.66,5.705,2.67
c0.011,0,0.021,0,0.032,0c2.189,0,4.271-0.957,5.696-2.621c5.075-5.926,124.304-146.165,124.304-235.932
C314.276,58.317,255.96,0,184.277,0z M184.322,349.251C160.385,319.48,69.277,201.453,69.277,130c0-63.411,51.589-115,115-115
s115,51.589,115,115C299.276,203.49,208.327,319.829,184.322,349.251z"/>
{symbol}
</svg>`
        .replace('symbol', symbol)
        .replace(/\{color\}/g, color)
        .replace(/\{colorOpacity\}/g, opts.colorOpacity)
        .replace(/\{backgroundColor\}/g, opts.backgroundColor)
        .replace(/\{borderColor\}/g, opts.borderColor)
        .replace(/\{size\}/g, size)
    return svg;
}

const getSVGBold = function(size, color, opts) {
    if (!opts.borderColor) {
        opts.borderColor = opts.backgroundColor;
    }
    let symbol = '';
    switch (opts.symbol) {
        case 'arrow_up':
            // symbol = `
            //     <line x1="184" y1="70" x2="184" y2="250" stroke="{contrastingColor}" stroke-width="15" stroke-linecap="round"/>
            //     <line x1="184" y1="70" x2="134" y2="120" stroke="{contrastingColor}" stroke-width="15" stroke-linecap="round"/>
            //     <line x1="184" y1="70" x2="234" y2="120" stroke="{contrastingColor}" stroke-width="15" stroke-linecap="round"/>
            // `.replace(/\{contrastingColor\}/g, opts.contrastingColor);
            symbol = `
    <g transform="matrix(0.7115373409 0 0 0.7115373409 7.491 7.489)" id="4kWez4xxaETKCXkK-M2wg"  >
        <g style=""   >
            <g transform="matrix(1 0 0 1 0 0)" id="iDpa1xB4a-5UZ_CDRGMsC"  >
                <line style="stroke: {contrastingColor}; stroke-width: 2; stroke-dasharray: none; stroke-linecap: round; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  x1="0" y1="-5.637065" x2="0" y2="5.637065" />
            </g>
            <g transform="matrix(1 0 0 1 -1.833975 -4.071215)" id="kFTXYbKxpIRQrjR_KnUhX"  >
                <line style="stroke: {contrastingColor}; stroke-width: 2; stroke-dasharray: none; stroke-linecap: round; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  x1="1.8339750000000001" y1="-1.56585" x2="-1.8339750000000001" y2="1.56585" />
            </g>
            <g transform="matrix(1 0 0 1 1.833975 -4.071215)" id="zXOLqV5dX3KROrq3R4Avx"  >
                <line style="stroke: {contrastingColor}; stroke-width: 2; stroke-dasharray: none; stroke-linecap: round; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  x1="-1.8339749999999997" y1="-1.56585" x2="1.8339749999999997" y2="1.56585" />
            </g>
        </g>
    </g>            `.replace(/\{contrastingColor\}/g, opts.contrastingColor);
            break;
    }
    let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="{size}" height="{size}"  viewBox="0 0 14.982 19.977">
  <g id="Group_717" data-name="Group 717" transform="translate(-207.018 -103.512)">
    <path id="Icon_awesome-map-marker-alt" data-name="Icon awesome-map-marker-alt" d="M6.721,19.574C1.052,11.355,0,10.512,0,7.491a7.491,7.491,0,0,1,14.982,0c0,3.02-1.052,3.864-6.721,12.082a.937.937,0,0,1-1.54,0Z" transform="translate(207.018 103.512)"/>
    <circle id="Ellipse_57" data-name="Ellipse 57" cx="4.927" cy="4.927" r="4.927" transform="translate(209.582 106.074)" fill="{color}{colorOpacity}"/>
  </g>
    {symbol}
</svg>
`
        .replace(/\{symbol\}/g, symbol)
        .replace(/\{color\}/g, color)
        .replace(/\{colorOpacity\}/g, opts.colorOpacity)
        .replace(/\{backgroundColor\}/g, opts.backgroundColor)
        .replace(/\{borderColor\}/g, opts.borderColor)
        .replace(/\{size\}/g, size)
    return svg;
}


const getSVGBold2 = function(size, color, opts) {
    if (!opts.borderColor) {
        opts.borderColor = opts.backgroundColor;
    }
    let symbol = '';
    let svg = '';
    switch (opts.symbol) {
        case 'arrow_up':
            svg = `<svg width="{size}" height="{size}" viewBox="0 0 14.982 19.977" xmlns="http://www.w3.org/2000/svg">
 <defs>
  <clipPath id="clipPath5-7">
   <rect x="-218.82" y="-291.27" width="37.243" height="45.417" fill="#fff" stroke="#fff" stroke-width=".26458"/>
  </clipPath>
 </defs>
 <g transform="translate(-207.02 -103.51)">
  <path id="Icon_awesome-map-marker-alt" transform="translate(207.02 103.51)" d="m6.721 19.574c-5.669-8.219-6.721-9.062-6.721-12.083a7.491 7.491 0 0 1 14.982 0c0 3.02-1.052 3.864-6.721 12.082a0.937 0.937 0 0 1-1.54 0z" fill="#000000" />
  <path transform="matrix(.28036 0 0 .26451 270.81 183.66)" d="m -200.73 -291.26 l -0.001 0.0005 c -0.819 0 -1.6381 0.2125 -2.0211 0.6372 l -15.816 17.536 c -0.4654 0.5148 -0.235 1.1386 0.5534 1.5131 c 0.7885 0.3733 1.9341 0.401 2.7792 0.0677 l 11.054 -4.3765 v 28.818 c 0 0.004 0.002 0.008 0.003 0.0119 a 3.452 1.1501 0 0 0 -0.004 0.0191 a 3.452 1.1501 0 0 0 3.453 1.1493 a 3.452 1.1501 0 0 0 3.4504 -1.1498 h -0.004 c 0 -0.0006 0.0005 -0.001 0.0005 -0.002 h 0.004 a 3.452 1.1501 0 0 0 -0.002 -0.01 c 0.0004 -0.007 0.004 -0.0123 0.004 -0.0191 v -28.818 l 11.054 4.3775 c 0.3932 0.1565 0.8541 0.2331 1.3126 0.2331 c 0.5241 0 1.0459 -0.1017 1.4661 -0.3007 c 0.7908 -0.3733 1.0188 -0.9971 0.5534 -1.5131 l -15.816 -17.536 c -0.383 -0.4246 -1.202 -0.6372 -2.0211 -0.6372 z z z"  fill="{color}" stroke-width=".197"/>
 </g>
</svg>`
              .replace(/\{symbol\}/g, symbol)
              .replace(/\{color\}/g, color)
              .replace(/\{colorOpacity\}/g, opts.colorOpacity)
              .replace(/\{backgroundColor\}/g, opts.backgroundColor)
              .replace(/\{borderColor\}/g, opts.borderColor)
              .replace(/\{size\}/g, size)
              .replace(/\{contrastingColor\}/g, opts.contrastingColor)
            break;
        case 'arrow_down':
            svg = `<svg width="{size}" height="{size}" viewBox="0 0 14.982 19.977" xmlns="http://www.w3.org/2000/svg">
 <g transform="translate(-207.02 -103.51)" >
  <path id="Icon_awesome-map-marker-alt" transform="translate(207.02 103.51)" d="m6.721 19.574c-5.669-8.219-6.721-9.062-6.721-12.083a7.491 7.491 0 0 1 14.982 0c0 3.02-1.052 3.864-6.721 12.082a0.937 0.937 0 0 1-1.54 0z" />
  <path d="m214.51 106.07a4.927 4.927 0 0 0-4.9272 4.9272 4.927 4.927 0 0 0 0.86205 2.7702c0.34344 0.53295 1.2549 1.7737 3.2921 4.7272 0.3729 0.53664 1.1675 0.53595 1.54-1e-3 2.052-2.9747 2.9339-4.1694 3.2348-4.6406a4.927 4.927 0 0 0 0.92545-2.8556 4.927 4.927 0 0 0-4.9272-4.9272z" fill="{color}"/>
  <circle cx="214.51" cy="111" r="2.664" stroke-width=".54074" />
 </g>
</svg>
`
              .replace(/\{symbol\}/g, symbol)
              .replace(/\{color\}/g, color)
              .replace(/\{colorOpacity\}/g, opts.colorOpacity)
              .replace(/\{backgroundColor\}/g, opts.backgroundColor)
              .replace(/\{borderColor\}/g, opts.borderColor)
              .replace(/\{size\}/g, size)
              .replace(/\{contrastingColor\}/g, opts.contrastingColor)
            break;
        default:
            svg = `<svg width="{size}" height="{size}" viewBox="0 0 14.982 19.977" xmlns="http://www.w3.org/2000/svg">
 <g transform="translate(-207.02 -103.51)" >
  <path id="Icon_awesome-map-marker-alt" transform="translate(207.02 103.51)" d="m6.721 19.574c-5.669-8.219-6.721-9.062-6.721-12.083a7.491 7.491 0 0 1 14.982 0c0 3.02-1.052 3.864-6.721 12.082a0.937 0.937 0 0 1-1.54 0z" />
  <path d="m214.51 106.07a4.927 4.927 0 0 0-4.9272 4.9272 4.927 4.927 0 0 0 0.86205 2.7702c0.34344 0.53295 1.2549 1.7737 3.2921 4.7272 0.3729 0.53664 1.1675 0.53595 1.54-1e-3 2.052-2.9747 2.9339-4.1694 3.2348-4.6406a4.927 4.927 0 0 0 0.92545-2.8556 4.927 4.927 0 0 0-4.9272-4.9272z" fill="{color}"/>
 </g>
</svg>`
              .replace(/\{symbol\}/g, symbol)
              .replace(/\{color\}/g, color)
              .replace(/\{colorOpacity\}/g, opts.colorOpacity)
              .replace(/\{backgroundColor\}/g, opts.backgroundColor)
              .replace(/\{borderColor\}/g, opts.borderColor)
              .replace(/\{size\}/g, size)
            break;
    }

    return svg;
//     let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="{size}" height="{size}"  viewBox="0 0 14.982 19.977">
//   <g id="Group_717" data-name="Group 717" transform="translate(-207.018 -103.512)">
//     <path id="Icon_awesome-map-marker-alt" data-name="Icon awesome-map-marker-alt" d="M6.721,19.574C1.052,11.355,0,10.512,0,7.491a7.491,7.491,0,0,1,14.982,0c0,3.02-1.052,3.864-6.721,12.082a.937.937,0,0,1-1.54,0Z" transform="translate(207.018 103.512)"/>
//     <circle id="Ellipse_57" data-name="Ellipse 57" cx="4.927" cy="4.927" r="4.927" transform="translate(209.582 106.074)" fill="{color}{colorOpacity}"/>
//   </g>
//     {symbol}
// </svg>
// `
//       .replace(/\{symbol\}/g, symbol)
//       .replace(/\{color\}/g, color)
//       .replace(/\{colorOpacity\}/g, opts.colorOpacity)
//       .replace(/\{backgroundColor\}/g, opts.backgroundColor)
//       .replace(/\{borderColor\}/g, opts.borderColor)
//       .replace(/\{size\}/g, size)
//     return svg;
}


export const getJobCluster = function(color, size, opts, icon_style ='classic') {
    var clusterId = ['job_pin', color, size, icon_style].join('_');
    if (!(clusterId in JobsOnMap.clusters)) {
        var pin = getJobPin(color, size, {}, icon_style);
        Targeo.Base.Map.getObjectManager().setClusterStyle(clusterId, {
            color: opts.backgroundColor || '#fff',
            borderColor: color,
            backgroundColor: color,
            font: 'bold 10px Verdana,sans-serif',
            offset: {x: 0, y: 0},
            icon: function(count) {
                return getJobClusterSymbol(color, 25 + 10 * Math.floor(Math.log10(count)), {});
            },
            zrange: {min: 23}
        });
    }
    return clusterId;
}

const getJobClusterSymbol = function(color, size, opts) {
    size += 10;
    let svg = `
        <svg viewBox="-24 -24 48 48" width="{size}" height="{size}" xmlns="http://www.w3.org/2000/svg">
            <circle cx="0" cy="0" r="14" fill="{color}"/>
            <g transform="scale(1.1)">
                <path d="M 7.5 -12.99 A 15 15 0 0 0 -7.5 -12.99 M -15 0 A 15 15 0 0 0 -7.5 12.99 M 7.5 12.99 A 15 15 0 0 0 15 0" fill="none" stroke="{color}bb" stroke-width="2"/>
            </g>
            <g transform="scale(1.3)">
                <path d="M 7.5 -12.99 A 15 15 0 0 0 -7.5 -12.99 M -15 0 A 15 15 0 0 0 -7.5 12.99 M 7.5 12.99 A 15 15 0 0 0 15 0" fill="none" stroke="{color}99" stroke-width="1.75"/>
            </g>
            <g transform="scale(1.5)">
                <path d="M 7.5 -12.99 A 15 15 0 0 0 -7.5 -12.99 M -15 0 A 15 15 0 0 0 -7.5 12.99 M 7.5 12.99 A 15 15 0 0 0 15 0" fill="none" stroke="{color}55" stroke-width="1.5"/>
            </g>
        </svg>
    `.replace(/\{color\}/g, color).replace(/\{size\}/g, size);
    let icon = {
        imageUrl: 'data:image/svg+xml;base64,'+btoa(svg),
        w: size,
        h: size,
        coordsAnchor: {x: Math.floor(size/2), y: Math.floor(size/2)}
    }
    return icon;
}


export class JobsOnMap extends EventTarget {

    static currentInstance;

    static pinSizes = {
        normal: 26,
        matching: 32,
        unmatching: 18
    };

    static clusters = {};

    constructor (options) {
        super();
        options = Object.assign({
            active: true,
            groupZoom: {
                27: ['city', 'quarter'],
                28: ['city'],
                29: ['community'],
                30: ['district'],
                32: ['province']
            },
            maxPointZoom: (get(customerSettings)).display.max_point_zoom || 26,
            filter: {},
            // projection: ['id', 'geom', 'target_date', 'ad_hoc', 'special_attributes>delivery_or_collection@doc', 'special_attributes>parcels@parcels'],
            projection: ['id', 'geom', 'special_attributes>delivery_or_collection@doc', 'special_attributes>parcels@parcels'],
            getMapObject: function(job) {
                return new Targeo.MapObject.Oval({x: job.geom.coordinates[0], y: job.geom.coordinates[1]}, 2, null, {interactive: false, zmax: 26, visible: true, strokeWeight: 0, strokeColor: '#000000', fillColor: '#000000'});
            }
        }, options || {});
        this.id = (Date.now() * 1000 + Math.random() * 1000).toString(16).replace(/\./g, '');
        console.log('jobs construct', this.id);
        this.options = options;
        this.Map = Targeo.Base.Map;
        this.filter = new ApiFilterBuilder(-1);
        this.filter.sortBy(null);
        this.filterQueries = JSON.parse(JSON.stringify(this.options.filter))
        this.projection = this.options.projection;
        this.active = this.options.active;
        this.api = null;
        this.unsubscribeApi = api.subscribe((function(v) { this.api = v; }).bind(this));
        this.token = null;
        this.jobs = {};
        this.loadedExtent = null;
        this.mapListeners = [
            this.Map.listen('onZoomChange', this.mapOnMove, false, this),
            this.Map.listen('onMoveEnd', this.mapOnMove, false, this)
        ];
        this.showBalloonOnLoad= null;
        this.initFilter();
        if (this.active) {
            this.activate();
        }
    }

    setFilter(queries) {
        this.filterQueries = JSON.parse(JSON.stringify(queries));
        if (this.filterQueries['$filter'] && Object.keys(this.filterQueries['$filter']).length === 0) {
            delete(this.filterQueries['$filter']);
        }
        this.jobsReload();
    }

    setProjection(projection) {
        this.projection = projection;
        this.initFilter();
        this.jobsReload();
    }

    initFilter() {
        this.filter.setProjectionFields(this.projection);
    }

    mapOnMove() {
        if (this.loadJobsTimeout) {
            clearTimeout(this.loadJobsTimeout);
        }
        if (this.checkZoom()) {
            this.loadJobsTimeout = setTimeout(this.jobsLoad.bind(this), 500);
        } else {
            this.jobsRemove();
        }
    }

    checkZoom() {
        if (this.Map.getZoom() <= this.options.maxPointZoom) {
            return true;
        } else {
            var groupzoom = Object.keys(this.options.groupZoom).map((z) => parseInt(z)).filter((z) => z >= this.Map.getZoom()).sort().shift();
            if (groupzoom) {
                return this.options.groupZoom[groupzoom];
            } else {
                return false;
            }
        }
    }

    jobsLoad() {
        var pointOrGroup = false;
        if (this.active && JobsOnMap.currentInstance === this && (pointOrGroup = this.checkZoom())) {
            let extent = this.Map.getVisibleExtent();
            if (!this.loadedExtent || this.loadedExtent.zoom != this.Map.getZoom() || this.loadedExtent.minX > extent.minX || this.loadedExtent.maxX < extent.maxX || this.loadedExtent.minY > extent.minY || this.loadedExtent.maxY < extent.maxY) {
                if (this.loadedExtent && this.loadedExtent.pointOrGroup !== (pointOrGroup === true ? pointOrGroup : JSON.stringify(pointOrGroup))) {
                    this.jobsRemove();
                }
                extent.minX -= (extent.maxX - extent.minX) / 4;
                extent.maxX += (extent.maxX - extent.minX) / 4;
                extent.minY -= (extent.maxY - extent.minY) / 4;
                extent.maxY += (extent.maxY - extent.minY) / 4;
                let extent2geojson = function(extent) {
                    return {type: 'Polygon', coordinates: [
                        [
                            [extent.minX, extent.minY],
                            [extent.maxX, extent.minY],
                            [extent.maxX, extent.maxY],
                            [extent.minX, extent.maxY],
                            [extent.minX, extent.minY]
                        ]
                    ]};
                };
                let geom = extent2geojson(extent);
                if (this.loadedExtent) {
                    let _difference = difference(polygon(geom.coordinates), polygon(extent2geojson(this.loadedExtent).coordinates));
                    if (_difference && _difference.geometry && _difference.geometry.coordinates.length == 1) {
                        geom = _difference.geometry;
                    }
                }
                this.loadedExtent = Object.assign(extent, {zoom: this.Map.getZoom(), pointOrGroup: (pointOrGroup === true ? pointOrGroup : JSON.stringify(pointOrGroup))});
                this.token = (Date.now() * 1000 + Math.random() * 1000).toString(16).replace(/\./g, '');
                console.log('jobs load', this.id, this.token, this.filterQueries);
                if (this.filterQueries['x_target_date'] || this.filterQueries['job.target_date'] || 'query' in this.filterQueries) {
                    let projection = this.projection.map((f) => 'location.'+f);
                    projection.push('id');
                    // projection.push('details>in_realisation@rl')
                    if (this.filterQueries['$filter']) {
                        projection.push('filter');
                    }
                    let relations = ['location']; // location*
                    var endpointfunc = 'query';
                    if (pointOrGroup !== true && !('query' in this.filterQueries)) {
                        endpointfunc = 'group';
                        relations.push('address');
                        this.filter.setGroupByFields(['assignment_id'].concat(pointOrGroup.map((f) => 'address.'+f)));
                        projection.splice(projection.indexOf('job.id'), 1, 'job_id');
                        projection = projection.map((f) => (f == 'job.geom' ? 'extent' : (f == 'filter' ? 'count' : 'min'))+'('+f+')');
                        //projection.push('envelope(geom@bounds)');
                        projection.push('count()');
                    } else {
                        projection.push('assignment_id', 'suggested_assignment_id');
                        this.filter.setGroupByFields([]);
                    }
                    this.filter.setProjectionFields(projection);
                    this.filter.setRelations(relations);
                    if ('query' in this.filterQueries) {
                        endpointfunc = 'query_in_assignment';
                        this.filterQueries['query']['geom'] = geom;
                    } else {
                        this.filterQueries['geom'] = geom;
                    }
                    this.api.getData(
                        'post',
                        '/assignment_jobs/' + endpointfunc + this.filter.getUri(),
                        this.filterQueries,
                        z.any(),
                        z.any()
                    ).then(this.jobsOnLoad.bind(this, this.token)).catch( err => {
                        console.error('jobs', err);
                        // resetFilterQuery();
                    });
                } else {
                    this.filterQueries['geom'] = JSON.stringify(geom);
                    let projection = this.projection.map((f) => f);
                    if (this.filterQueries['$filter']) {
                        projection.push('filter');
                    }
                    var endpointfunc = 'query';
                    if (pointOrGroup !== true) {
                        endpointfunc = 'group';
                        this.filter.setRelations(['address']);
                        this.filter.setGroupByFields(pointOrGroup.map((f) => 'address.'+f));
                        projection = projection.map((f) => (f == 'geom' ? 'extent' : (f == 'filter' ? 'count' : 'min'))+'('+f+')');
                        //projection.push('envelope(geom@bounds)');
                        projection.push('count()');
                    } else {
                        this.filter.setRelations([]);
                        this.filter.setGroupByFields([]);
                    }
                    this.filter.setProjectionFields(projection);
                    // try {
                        this.api.getData(
                            'post',
                            '/locations/' + endpointfunc + this.filter.getUri(),
                            this.filterQueries,
                            z.any(),
                            z.any()
                            //z.array(JobResponseSchema.pick(Object.assign({doc: true}, ...this.filter.getProjectionFields().map((e, i) => ({[e]: true})))))
                        ).then(this.jobsOnLoad.bind(this, this.token)).catch(err => {
                            console.error('jobs', err);
                            // resetFilterQuery();
                        });
                    // } catch (err) {
                    //     alert('Error: ' + err);
                    //     resetFilterQuery();
                    // }
                }
            }
        }
    }

    jobsOnLoad(token, jobs) {
        if (token == this.token && JobsOnMap.currentInstance === this) {
            console.log('jobs loaded', this.id, this.token, jobs.length, Object.keys(this.jobs).length);
            let newjobs = {}
            this.Map.getObjectManager().disableRefreshing('LastMile:JobsOnMap');
            for (let job of jobs) {
                if (job.job) {
                    job.ajId = job.id;
                    job = Object.assign(job, job.job);
                    delete(job.job);
                } else if (job.job_id) {
                    job.ajId = job.id;
                    job.id = job.job_id;
                }
                if (job.geom) {
                    if (job.count) {
                        if (typeof(job.geom) == 'string') {
                            job.geom = job.geom.match(/([\d\.]+) ([\d\.]+),([\d\.]+) ([\d\.]+)/).slice(1).map((c) => parseFloat(c));
                            job.geom = {type: 'Polygon', coordinates: [[
                                [job.geom[0], job.geom[1]],
                                [job.geom[2], job.geom[1]],
                                [job.geom[2], job.geom[3]],
                                [job.geom[0], job.geom[3]],
                                [job.geom[0], job.geom[1]]
                            ]]};
                        }
                        if (job.geom.type == 'Polygon') {
                            job.bounds = this.geomToBounds(job.geom);
                            job.geom = {type: 'Point', coordinates: [(job.bounds.minX+job.bounds.maxX)/2, (job.bounds.minY+job.bounds.maxY)/2]}
                        } else if (job.bounds) {
                            job.bounds = this.geomToBounds(job.bounds);
                        }
                    }
                    newjobs[job.id] = true;
                    if (!(job.id in this.jobs)) {
                        this.jobs[job.id] = this.options.getMapObject(job);
                        if (job.count && job.count > 1 && job.bounds) {
                            this.jobs[job.id].listenOnce('onClick', (function(job) {
                                this.Map.zoomToBounds(job.bounds, true, 10, {zmax: this.options.maxPointZoom});
                            }).bind(this, job));
                        }
                        this.Map.UOAdd(this.jobs[job.id]);
                    }
                }
                if (this.showBalloonOnLoad && this.showBalloonOnLoad.jobId == job.id) {
                    clearTimeout(this.showBalloonOnLoad.timeout);
                    this.showBalloonOnLoad = null;
                    setTimeout((function () {
                        if (typeof this.jobs[job.id] !== 'undefined') { // FIXED: https://lupus.automapa.pl/organizations/automapa/issues/4395/?project=14&query=is%3Aunresolved
                            this.Map.getObjectManager().showBalloon(this.jobs[job.id].id);
                        }
                    }).bind(this), 250);
                }
            }
            for (let jobId in this.jobs) {
                let coords = this.jobs[jobId].coords;
                if (coords.x < this.loadedExtent.minX || coords.y < this.loadedExtent.minY || coords.x > this.loadedExtent.maxX || coords.y > this.loadedExtent.maxY) {
                    this.Map.UORemove(this.jobs[jobId].id);
                    delete(this.jobs[jobId]);
                }
            }
            this.Map.getObjectManager().enableRefreshing('LastMile:JobsOnMap');
            console.log('jobs on map count', Object.keys(this.jobs).length);
        }
    }

    jobsRemove() {
        console.log('jobs remove', this.id, this.token);
        this.token = null;
        this.loadedExtent = null;
        this.Map.getObjectManager().disableRefreshing('LastMile:JobsOnMap');
        for (let jobId in this.jobs) {
            this.Map.UORemove(this.jobs[jobId].id);
        }
        this.jobs = {}
        this.Map.getObjectManager().enableRefreshing('LastMile:JobsOnMap');
    }

    jobsReload() {
        this.jobsRemove();
        this.jobsLoad();
    }

    jobReloadSingle(jobId) {
        if (jobId in this.jobs) {
            this.Map.UORemove(this.jobs[jobId].id);
            if (typeof this.jobs[jobId]!=='undefined') delete(this.jobs[jobId]);
        }
        this.loadedExtent = null;
        this.jobsLoad();
    }

    jobShowBalloon(jobId, show = true) {
        if (this.showBalloonOnLoad) {
            clearTimeout(this.showBalloonOnLoad.timeout);
            this.showBalloonOnLoad = null;
        }
        if (this.jobs[jobId] && this.Map.getObjectManager().objects[this.jobs[jobId].id]) {
            if (show) {
                this.Map.getObjectManager().showBalloon(this.jobs[jobId].id);
            } else {
                this.Map.getObjectManager().hideBalloon(this.jobs[jobId].id);
            }
        } else {
            this.showBalloonOnLoad = {
                jobId: jobId,
                timeout: setTimeout((function() {
                    this.showBalloonOnLoad = null;
                }).bind(this), 3000)
            }
        }
    }

    zoomBestFit(toFiltered) {
        this.filter.setGroupByFields([]);
        this.filter.setProjectionFields([]);
        let endpoint;
        let apifunc = 'geom_bounds';
        if (this.filterQueries['x_target_date'] || this.filterQueries['job.target_date'] || 'query' in this.filterQueries) {
            endpoint = 'assignment_jobs';
            if ('query' in this.filterQueries) {
                apifunc = 'geom_bounds_in_assignment';
            }
            this.filter.setRelations(['job*']);
        } else {
            endpoint = 'locations';
            this.filter.setRelations([]);
        }
        var queries = JSON.parse(JSON.stringify(this.filterQueries));
        if (apifunc == 'geom_bounds') {
            delete(queries['geom']);
            if (toFiltered) {
                queries = Object.assign(queries, queries['$filter']);
            }
            delete(queries['$filter']);
        } else {
            delete(queries['query']['geom']);
            if (toFiltered) {
                queries['query'] = Object.assign(queries['query'], queries['query']['$filter']);
            }
            delete(queries['query']['$filter']);
        }
        this.api.getData(
            'post',
            '/'+endpoint+'/'+apifunc + this.filter.getUri(),
            queries,
            z.any(),
            z.any()
        ).then((function(response) {
            if (response && response[0] && response[0].geom) {
                let bounds = this.geomToBounds(response[0].geom);
                if (bounds) {
                    this.Map.zoomToBounds(bounds, false, [80, 120, 20, 180]);
                }
            }
        }).bind(this)).catch( err => {
            console.error('jobs', err);
            // resetFilterQuery();
        });
    }

    geomToBounds(geom) {
        let bounds = null;
        if (geom.type == 'Polygon') {
            let coords = geom.coordinates;
            bounds = {minX: 180, minY: 180, maxX: -180, maxY: -180};
            for (let i = 0; i < coords[0].length; i++) {
                bounds.minX = Math.min(bounds.minX, coords[0][i][0]);
                bounds.minY = Math.min(bounds.minY, coords[0][i][1]);
                bounds.maxX = Math.max(bounds.maxX, coords[0][i][0]);
                bounds.maxY = Math.max(bounds.maxY, coords[0][i][1]);
            }
        } else if (geom.type == 'Point') {
            bounds = {minX: geom.coordinates[0], minY: geom.coordinates[1], maxX: geom.coordinates[0], maxY: geom.coordinates[1]};
        }
        return bounds;
    }

    activate() {
        this.active = true;
        if (JobsOnMap.currentInstance && JobsOnMap.currentInstance !== this) {
            JobsOnMap.currentInstance.deactivate();
        }
        JobsOnMap.currentInstance = this;
        if (this.options.addJob) {
            this.Map.modules.ContextMenu.registerOption('addJob', {
                label: _('Add job manually'),
                icon: Targeo.Base.getSVGSrc('<path d="M17,10.91v3.77l-.8.78a5.48,5.48,0,0,0-8.4,0L7,14.68V4h3.09a5.51,5.51,0,0,1,.72-2H6.5A1.5,1.5,0,0,0,5,3.5V16l3.65,2a3.49,3.49,0,0,1,6.7,0L19,16V10.19A5.51,5.51,0,0,1,17,10.91Z" fill="#77b024"/><path d="M12,17a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z" fill="#77b024"/><path d="M16,0a5,5,0,1,0,5,5A5,5,0,0,0,16,0Zm3,6H17V8H15V6H13V4h2V2h2V4h2Z" fill="#77b024"/>', 24, 24),
                handler: (function(obj) {
                    ConnectionApi.revgeo(get(api), obj.coords.x, obj.coords.y).then((function(response) {
                        // Zachowaj kliknięte współrzędne nawet gdy revgeo nic nie zwróci (np. punkt
                        // poza zasięgiem geokodera PL). Bez tego dla adresów zagranicznych x/y są
                        // undefined i centerMap() wybiega poza zakres -> biała mapa.
                        const detail = Object.assign({x: obj.coords.x, y: obj.coords.y}, response);
                        this.dispatchEvent(new CustomEvent('jobadd', {detail: detail}));
                    }).bind(this));
                }).bind(this),
                test: function(obj) {
                    return obj.coords && typeof(obj.coords.x) == 'number' && typeof(obj.coords.y) == 'number';
                }
            });
            this.Map.modules.ContextMenu.changeContextMenuDefaultOptions({
                add: [{before: 0, name: '|'}, {before: 0, name: 'addJob'}]
            });
        }
        this.jobsLoad();
    }

    deactivate() {
        this.Map.modules.ContextMenu.changeContextMenuDefaultOptions({remove: ['addJob']});
        this.active = false;
        if (JobsOnMap.currentInstance === this) {
            this.jobsRemove();
            JobsOnMap.currentInstance = null;
        }
    }

    destroy() {
        console.log('jobs destroy', this.id);
        this.Map.modules.ContextMenu.changeContextMenuDefaultOptions({remove: ['addJob']});
        this.unsubscribeApi();
        if (JobsOnMap.currentInstance === this) {
            this.jobsRemove();
            JobsOnMap.currentInstance = null;
        }
        this.mapListeners.forEach((l) => { this.Map.unlistenByKey(l); });
        this.mapListeners = [];
    }

    zoomTo(x,y, zoom=21) {
        Targeo.Base.Map.zoomAndCenter({ x, y}, zoom);
    }

}